export default {"src":"/_next/static/media/noMatchesAvailable.56351215.svg","height":98,"width":98,"blurWidth":0,"blurHeight":0};